import { Component, Input, ViewEncapsulation } from '@angular/core';
import { BildungsangebotTerminDetail } from '../../../../model';
import { WeiterbildungsinformationenComponent } from '../detail-inhalt/weiterbildungsinformationen/weiterbildungsinformationen.component';
import { WeiterbildungsinhalteComponent } from '../detail-inhalt/weiterbildungsinhalte/weiterbildungsinhalte.component';
import { ZugangsinformationenComponent } from '../detail-inhalt/zugangsinformationen/zugangsinformationen.component';
import { DetailKachelComponent } from '../detail-kachel/detail-kachel.component';

@Component({
  selector: 'now-wbsuche-lib-tab-informationen',
  templateUrl: './tab-informationen.component.html',
  encapsulation: ViewEncapsulation.None,
  imports: [
    DetailKachelComponent,
    WeiterbildungsinhalteComponent,
    ZugangsinformationenComponent,
    WeiterbildungsinformationenComponent
  ]
})
export class TabInformationenComponent {
  @Input()
  public termin!: BildungsangebotTerminDetail;

  public collapseStates: {
    weiterbildungsinhalte?: boolean;
  } = {};

  get showZugangsinformationen(): boolean {
    const {
      teilnehmerMin,
      teilnehmerMax,
      angebot: { zugang, anrechnung, zielgruppe, behinderungen }
    } = this.termin;
    return (
      !!zugang ||
      !!anrechnung ||
      !!zielgruppe ||
      !!teilnehmerMin ||
      !!teilnehmerMax ||
      behinderungen?.length > 0
    );
  }
}
